export default function scrollIntoViewIfItIsNot(elementId, upperBoundElementId, upperBoundSide, lowerBoundElementId, lowerBoundSide) {
    const element = document.getElementById(elementId);
    if (!element)
        return;
    const elementRect = element.getBoundingClientRect();
    let topBound;
    let bottomBound;
    // Determine the upper bound
    if (upperBoundElementId === 'viewport') {
        topBound = 0; // Top of the viewport
    }
    else {
        const upperBoundElement = document.getElementById(upperBoundElementId);
        if (!upperBoundElement)
            return;
        const upperBoundRect = upperBoundElement.getBoundingClientRect();
        topBound = upperBoundRect[upperBoundSide];
    }
    // Determine the lower bound
    if (lowerBoundElementId === 'viewport') {
        bottomBound = window.innerHeight; // Bottom of the viewport
    }
    else {
        const lowerBoundElement = document.getElementById(lowerBoundElementId);
        if (!lowerBoundElement)
            return;
        const lowerBoundRect = lowerBoundElement.getBoundingClientRect();
        bottomBound = lowerBoundRect[lowerBoundSide];
    }
    // Check if the element is completely within the bounds
    const isVisible = elementRect.top >= topBound && elementRect.bottom <= bottomBound;
    if (!isVisible)
        element.scrollIntoView({ behavior: 'smooth' });
}
